import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import img from '../assets/images/logo-sinfondo.png'

import data from '../assets/fake-data/data-blog2'
import Action from '../components/layouts/Action';

const Habitaciones = () => {

    const [visible, setVisible] = useState(9);
    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 3);
    }

    return (
        <div className='page-blog bg'>
            <Header />
            <section className="tf-section page-title">
                <div className="container">
                    <div className="col-md-12">
                        <div className="page-title__body rm">
                            <div className="block-text pt-12">
                                <h2 className="sub-title mb-20 ">Habitaciones</h2>
                                <p className="fs-24 mb-33 sub-tt" >Pensadas para tu descanso y tu comodidad <br /> Contamos con habitaciones amplias, iluminadas y adaptadas para diferentes tipos de huéspedes. </p>
                            </div>
                            <img className="s2" src={img} alt="Monteno" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="blog-grid">
                <div className="container">
                    <div className="row">
                        {
                            data.slice(0, visible).map((data, index) => (
                                <div key={index} className="col-xl-4 col-md-6 col-12 fl-item2">
                                    <div className="blog-box">
                                        <div className="blog-img">
                                            <Link to={data.links}>
                                                <img src={data.img} alt="Monteno" />
                                            </Link>
                                        </div>
                                        <div className="blog-content">
                                            <Link to={data.links} className="title h10" style={{ marginBottom: '10px', display: 'block' }}>{data.category}</Link>
                                            <ul className="meta"><li><span style={{ color: 'var(--text-color, #ffffffff)' }}>{data.title}</span></li></ul>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        {
                            visible < data.length &&
                            <div className="col-12">
                                <div className="load-more center">
                                    <Link id="loadmore" className="btn-action style-2" to="#" onClick={showMoreItems}>
                                        Ver Mas!
                                    </Link>
                                </div>
                            </div>
                        }


                    </div>
                </div>
            </section>

            <Action />
            <Footer />
        </div>
    );
}

export default Habitaciones;